import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Heart, Mail, Github } from "lucide-react";

const Footer = ({ openHowToPlay, openGenerateCards }) => {
  const currentYear = new Date().getFullYear();

  const gameTypes = [
    { name: "15-Ball Express", icon: "🏎️" },
    { name: "30-Ball Speed", icon: "⚡" },
    { name: "50-Ball Quick", icon: "🔄" },
    { name: "75-Ball American", icon: "🇺🇸" },
    { name: "90-Ball British", icon: "🇬🇧" },
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Call My Bingo */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 flex items-center">
              <svg
                className="h-6 w-6 fill-current text-purple-400 mr-2"
                viewBox="0 0 24 24"
              >
                <path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z" />
              </svg>
              Call My Bingo
            </h3>
            <p className="text-sm text-gray-400">
              The ultimate bingo caller for all your game nights! Perfect for
              parties, classroom activities, or virtual gatherings.
            </p>
           
          </div>

          {/* Game Types */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">
              Game Types
            </h3>
            <ul className="space-y-2">
              {gameTypes.map((game, index) => (
                <li key={index}>
                  <Link
                    to={`/?gameType=${game.name.split("-")[0].trim()}`}
                    className="text-gray-400 hover:text-white transition duration-150 flex items-center"
                  >
                    <span className="mr-2">{game.icon}</span>
                    {game.name} Bingo
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/how-to-play-bingo"
                  className="text-gray-400 hover:text-white transition duration-150"
                >
                  How to Play Bingo
                </Link>
              </li>
              <li>
                <button
                  className="text-gray-400 hover:text-white transition duration-150"
                  onClick={openGenerateCards}
                >
                  Printable Bingo Cards
                </button>
              </li>
              <li>
                <a
                  href="https://pickspin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition duration-150 flex items-center"
                >
                  <span>Visit PickSpin</span>
                  <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Connect</h3>
            <div className="space-y-3">
              <a
                href="mailto:info@callmybingo.com"
                className="text-gray-400 hover:text-white transition duration-150 flex items-center"
              >
                <Mail size={18} className="mr-2" />
                <span>info@callmybingo.com</span>
              </a>
              <a
                href="https://github.com/ioannissuarez"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition duration-150 flex items-center"
              >
               
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-400 text-center">
          <p>© {currentYear} Call My Bingo. All rights reserved.</p>
          <p className="mt-2">
            <a href="#" className="hover:text-white transition duration-150">
              Privacy Policy
            </a>
            {" • "}
            <a href="#" className="hover:text-white transition duration-150">
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
